import React, { useEffect, useRef, useState } from "react";
import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Accordion,
} from "@chakra-ui/react";

import "react-datepicker/dist/react-datepicker.css";
import {Col,Form,Row} from "react-bootstrap";
import "rsuite/dist/rsuite.min.css";
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from "@chakra-ui/styled-system";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncAddUser } from "redux/userSlice";
import { fetchAsyncUpdateUser } from "redux/userSlice";
import { default_access } from "./manageAccess";
import AccordionComponent from "./moduleAcordion";
import InputFormControl from "../component/inputFormControl";
import useExpenseModule from "hooks/organizaton/useExpenseModule";
import useSalesInvoiceModule from "hooks/organizaton/useSalesInvoiceModule";
import SubmitButton from "../component/buttons/submitButton";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const xl = defineStyle({
  px: "6",
  py: "2",
  fontSize: "xl",
});

const sm = defineStyle({
  fontSize: "sm",
  py: "6",
});

const sizes = {
  xl: definePartsStyle({ header: sm, dialog: xl }),
};

export const modalTheme = defineMultiStyleConfig({
  sizes,
});

const UserForm = ({ openModel, closeModel, userData, isEdit, refreshList }) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const [selectedModule, setSelectedModule] = useState("");
  const [defaultAccess, setDefaultAccess] = useState([]);
  const [editActive, setEditActive] = useState(false);
  const [editValue, setEditValue] = useState({
    module: "",
    access: "",
  });
  const {moduleType} = useExpenseModule();
  const {salesModule} = useSalesInvoiceModule();
  const [authFormattedData, setAuthFormattedData] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    auth: defaultAccess,
  });

  useEffect(() => {
    const moduleAccess = moduleType.map((item) => {
      return {
        module: item.name,
        access: "No Access",
        id: "expenses",
      };
    });
    const salesModuleAccess = salesModule.map((item) => {
      return {
        module: item.name,
        access: "No Access",
        id: "invoices",
      };
    });
    setDefaultAccess([
      ...default_access,
      ...moduleAccess,
      ...salesModuleAccess,
    ]);
  }, [moduleType, default_access, salesModule]);

  useEffect(() => {
    if (userData && isEdit) {
      const { name, email, auth } = userData;
      const authMap = new Map(auth.map((item) => [item.module, item.access]));

      const combinedAccess = defaultAccess.map((item) => {
        return {
          ...item,
          access: authMap.has(item.module)
            ? authMap.get(item.module)
            : item.access,
        };
      });
      setFormData({
        ...formData,
        name: name,
        email: email,
        auth: combinedAccess,
      });
    } else {
      setFormData({
        ...formData,
        auth: defaultAccess,
      });
    }
  }, [isEdit, defaultAccess]);

  const handleOnChange = (e) => {
    const name = e?.target?.name;
    const value = e?.target?.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const faEditClick = (option) => {
    setSelectedModule(option?.module);
    setEditValue(option);
    setEditActive(true);
  };
  const faCheckMarkClick = (option) => {
    setSelectedModule("");
    const auth_data = formData?.auth?.map((item) => {
      if (item.module === editValue?.module) {
        const obj = {
          ...item,
          access: editValue?.access,
        };
        return obj;
      } else {
        return item;
      }
    });

    if (auth_data) {
      setFormData({
        ...formData,
        auth: auth_data,
      });
    }
    setEditValue({
      module: "",
      access: "",
    });
    setEditActive(false);
  };
  const [errors, setErrors] = useState({
    name: "",
    email: "",
  });

  const handleEditModuleAccess = (e) => {
    const value = e?.target?.value;
    setEditValue({
      ...editValue,
      access: value,
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddUser = () => {
    dispatch(fetchAsyncAddUser(formData))
      .then((res) => {
        if (res?.payload) {
          refreshList();
          closeModel();
          addToast(`New user created successfully!`, { appearance: "success" });
        } else {
          addToast(`${res?.error?.message}`, { appearance: "error" });
        }
      })
      .catch((err) => {
        addToast("user hase been not created", { appearance: "error" });
      });
  };

  const handleEditUser = () => {
    dispatch(fetchAsyncUpdateUser({ id: userData._id, userData: formData }))
      .then((res) => {
        if (res?.payload) {
          const { auth, name, email } = res?.payload;
          setFormData({
            name: name,
            email: email,
            auth: auth,
          });

          refreshList();
          closeModel();
          addToast(`User details have been updated successfully!`, {
            appearance: "success",
          });
        }
      })
      .catch((err) => {
        addToast("Error", { appearance: "error" });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (!isEdit) {
        handleAddUser();
      } else {
        handleEditUser();
      }
    }
  };

  useEffect(() => {}, [isEdit]);

  const finalRef = useRef(null);

  const groupAuthModuleDataById = (authArray) => {
    const grouped = {};
    authArray.forEach((obj) => {
      const _id = obj.id;
      if (_id) {
        if (!grouped[_id]) {
          grouped[_id] = [];
        }
        grouped[_id].push(obj);
      }
    });

    const result = [];
    for (const _id in grouped) {
      result.push({ _id, data: grouped[_id] });
    }

    return result;
  };

  useEffect(() => {
    const data = groupAuthModuleDataById(formData?.auth || []);
    setAuthFormattedData(data);
  }, [formData?.auth]);

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModel}
        onClose={() => {
          closeModel();
        }}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          top="0"
          margin="0 auto"
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="modal-heading expense-modal-header">
              {isEdit ? "Edit" : "Add"} User
            </ModalHeader>
            <ModalCloseButton />
          </div>
          <ModalBody>
            <Form className="addForm">
              <div className="form-card">
                <h5>User Details</h5>
                <Row>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Full Name <span className="span-star">*</span>
                      </Form.Label>
                      <InputFormControl
                        placeholder="Enter Name"
                        value={formData?.name}
                        name="name"
                        isInvalid={!!errors.name}
                        handleChange={(e) => handleOnChange(e)}
                      />
                    </Box>
                    <p className="form_error">{errors.name}</p>
                  </Col>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Email <span className="span-star">*</span>
                      </Form.Label>
                      <InputFormControl
                        type="email"
                        placeholder="Enter Email"
                        value={formData?.email}
                        disabled={isEdit}
                        name="email"
                        isInvalid={!!errors.email}
                        handleChange={(e) => handleOnChange(e)}
                      />
                    </Box>
                    <p className="form_error">{errors.email}</p>
                  </Col>
                </Row>
              </div>
              <div className="form-card mt-3">
                <h5>Module Access Details</h5>
                <Box className="accordion-box user-access-accordion ">
                  <Accordion
                    className="accordion"
                    defaultIndex={[0]}
                    allowMultiple
                  >
                    {authFormattedData &&
                      authFormattedData?.length > 0 &&
                      authFormattedData?.map((authData, index) => {
                        return (
                          <AccordionComponent
                            id={authData?._id}
                            authData={authData?.data || []}
                            editActive={editActive}
                            selectedModule={selectedModule}
                            editValue={editValue}
                            errors={errors}
                            handleEditModuleAccess={handleEditModuleAccess}
                            faEditClick={(item) => faEditClick(item)}
                            faCheckMarkClick={(item) => faCheckMarkClick(item)}
                          />
                        );
                      })}
                  </Accordion>
                </Box>
              </div>
              <Row className="role_add_btn">
                <SubmitButton
                  handleClick={(e) => handleSubmit(e)}
                  customClass="mt-1 px-4"
                  btnTxt="Submit"
                />
              </Row>
            </Form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UserForm;
